import { n } from "../lib/format";

interface Props {
  label: string;
  valor: number;
  destaqueAtrasadas?: boolean;
  onClick?: () => void;
}

export function CardTopo({ label, valor, destaqueAtrasadas, onClick }: Props) {
  return (
    <div
      className={"card-topo" + (destaqueAtrasadas ? " atrasadas" : "")}
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      <div className="label">{label}</div>
      <div className="valor">{n(valor)}</div>
    </div>
  );
}
